(() => {
/*
-is there a bug when thumbnail click at fullscreen, the bottom row disappears during card transition??
-for videos: media="(min-width: 800px)" etc
-check project container widths: when project as scrollbar vs when it doesnt
*/ const $9ddde22dc8a5d9b0$var$viewport_variable = {
    height_var_name: "--vh",
    _isMobileDevice () {
        const userAgent = navigator.userAgent || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return mobileRegex.test(userAgent);
    },
    _onResize () {
        const vh = window.innerHeight;
        document.documentElement.style.setProperty(this.height_var_name, `${vh}px`);
    },
    _handleViewportHeightVariable () {
        if (this._isMobileDevice()) {
            this._onResize();
            window.addEventListener("resize", this._onResize);
        }
    },
    init () {
        this._handleViewportHeightVariable();
    }
};
var $9ddde22dc8a5d9b0$export$2e2bcd8739ae039 = $9ddde22dc8a5d9b0$var$viewport_variable;


// Video
// -------------------------------------------------------------------------------------------------------
const $0cf9af5d9dc9aed9$var$video = {
    buffer_text: "Buffering...",
    classes: {
        buffering: "buffering",
        ready: "ready",
        hidden: "hidden",
        play_button: "play-btn"
    },
    _togglePlayButton (button_el) {
        button_el.classList.toggle(this.classes.hidden);
    },
    _buffer (video_el, button_el) {
        video_el.classList.add(this.classes.buffering);
        button_el.innerText = this.buffer_text;
        video_el.load();
    },
    _bufferThenFirstPlay (video_el, button_el) {
        const classes = this.classes;
        if (video_el.classList.contains(classes.buffering)) return;
        const play_text = button_el.innerText;
        this._buffer(video_el, button_el);
        function firstPlay() {
            video_el.classList.remove(classes.buffering);
            video_el.classList.add(classes.ready);
            video_el.play();
            button_el.toggle();
            button_el.innerText = play_text;
            video_el.removeEventListener("canplaythrough", firstPlay);
        }
        video_el.addEventListener("canplaythrough", firstPlay);
    },
    _togglePlay (video_el, button_el) {
        video_el.paused ? video_el.play() : video_el.pause();
        button_el.toggle();
    },
    _addClickListeners (video_el, button_el) {
        const video_classes = video_el.classList;
        const classes = this.classes;
        Array(video_el, button_el).forEach((el)=>{
            el.addEventListener("click", ()=>{
                if (!video_classes.contains(classes.ready)) {
                    this._bufferThenFirstPlay(video_el, button_el);
                    return;
                }
                this._togglePlay(video_el, button_el);
            });
        });
    },
    _addEndedListener (video_el, button_el) {
        video_el.addEventListener("ended", ()=>{
            video_el.currentTime = 0;
            button_el.toggle();
        });
    },
    interactionHandler (video_el) {
        const parent_el = video_el.parentElement;
        const button_el = parent_el.querySelector(`.${this.classes.play_button}`);
        button_el.toggle = this._togglePlayButton.bind(this, button_el);
        this._addClickListeners(video_el, button_el);
        this._addEndedListener(video_el, button_el);
    }
};
var $0cf9af5d9dc9aed9$export$2e2bcd8739ae039 = $0cf9af5d9dc9aed9$var$video;


const $cf43a84b5a511ae6$var$pinch_zoom = {
    max_scale: 3,
    current_scale: 1,
    image_z_index: "999",
    _distance (e) {
        return Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
    },
    _applyTransform (image_el, transform, transition = "none") {
        image_el.style.transform = transform;
        image_el.style.transition = transition;
    },
    _handleTouchStart (e, image_el) {
        if (e.touches.length === 2) {
            e.preventDefault();
            this.start = {
                x: (e.touches[0].pageX + e.touches[1].pageX) / 2,
                y: (e.touches[0].pageY + e.touches[1].pageY) / 2,
                distance: this._distance(e),
                initial_scale: this.current_scale
            };
        }
    },
    _handleTouchMove (e, image_el) {
        if (e.touches.length === 2) {
            e.preventDefault();
            const currentX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
            const currentY = (e.touches[0].pageY + e.touches[1].pageY) / 2;
            const deltaX = currentX - this.start.x;
            const deltaY = currentY - this.start.y;
            const delta_distance = this._distance(e);
            const scale = this.start.initial_scale * (delta_distance / this.start.distance);
            this.image_scale = Math.min(Math.max(1, scale), this.max_scale);
            if (this.image_scale > 1 && image_el.style.zIndex !== this.image_z_index) image_el.style.zIndex = this.image_z_index;
            // Include both scale and translation in the transform
            const transform = `translate(${deltaX}px, ${deltaY}px) scale(${this.image_scale})`;
            requestAnimationFrame(()=>this._applyTransform(image_el, transform));
        }
    },
    _handleTouchEnd (image_el) {
        const transform = `scale(1)`;
        requestAnimationFrame(()=>this._applyTransform(image_el, transform, "all .2s ease-out"));
        image_el.addEventListener("transitionend", ()=>{
            this.current_scale = 1;
            image_el.style.zIndex = "";
        }, {
            once: true
        });
    },
    addPinchZoomHandler (image_el) {
        image_el.addEventListener("touchstart", (e)=>this._handleTouchStart(e, image_el));
        image_el.addEventListener("touchmove", (e)=>this._handleTouchMove(e, image_el));
        image_el.addEventListener("touchend", ()=>this._handleTouchEnd(image_el));
    }
};
var $cf43a84b5a511ae6$export$2e2bcd8739ae039 = $cf43a84b5a511ae6$var$pinch_zoom;


// Lightbox
// -------------------------------------------------------------------------------------------------------
const $b7e814115a0b0754$var$light_box = {
    id: "light-box",
    sizes: "100vw",
    hidden_class: "hidden",
    excluded_classes: [
        "r-poster"
    ],
    _toggleHiddenClass (container_el) {
        container_el.classList.toggle(this.hidden_class);
    },
    _clearLightBoxImageSrc () {
        this.image.srcset = "";
        this.image.src = "";
    },
    _updateLightBoxImageSrc (image_el) {
        this.image.srcset = image_el.srcset;
        this.image.src = image_el.src;
        this.image.alt = image_el.alt;
    },
    _addLightboxClickListener (container_el) {
        container_el.addEventListener("click", ()=>this._toggleHiddenClass(container_el));
    },
    _addImageClickListener (source_image_el) {
        source_image_el.addEventListener("click", ()=>{
            this._onLoad = ()=>{
                this.image.removeEventListener("load", this._onLoad);
                this.launch();
            };
            this.image.addEventListener("load", this._onLoad);
            this._updateLightBoxImageSrc(source_image_el);
        });
    },
    _testExcludedClasses (source_image_el) {
        const wrapper_el = source_image_el.parentElement;
        const has_excluded_class = this.excluded_classes.some((excluded_class)=>wrapper_el.classList.contains(excluded_class));
        return has_excluded_class;
    },
    addImageClickHandler (source_image_el) {
        const has_excluded_class = this._testExcludedClasses(source_image_el);
        if (has_excluded_class) return;
        this._addImageClickListener(source_image_el);
    },
    launch () {
        this._toggleHiddenClass(this.container_el);
    },
    init () {
        this.container_el = document.createElement("div");
        this.container_el.id = this.id;
        this.container_el.classList.add(this.hidden_class);
        this._addLightboxClickListener(this.container_el);
        this.image = document.createElement("img");
        this.image.sizes = this.sizes;
        (0, $cf43a84b5a511ae6$export$2e2bcd8739ae039).addPinchZoomHandler(this.image);
        this.container_el.appendChild(this.image);
        document.body.prepend(this.container_el);
    }
};
var $b7e814115a0b0754$export$2e2bcd8739ae039 = $b7e814115a0b0754$var$light_box;



// Image
// -------------------------------------------------------------------------------------------------------
const $b7a8c6d4d20803eb$var$image = {
    addInteractionHandlers (image_el) {
        (0, $b7e814115a0b0754$export$2e2bcd8739ae039).addImageClickHandler(image_el);
        (0, $cf43a84b5a511ae6$export$2e2bcd8739ae039).addPinchZoomHandler(image_el);
    }
};
var $b7a8c6d4d20803eb$export$2e2bcd8739ae039 = $b7a8c6d4d20803eb$var$image;


// Lazyload
// -------------------------------------------------------------------------------------------------------
const $68be57c3a737ff01$var$lazy_load = {
    _mediaFunctionCaller (el, media_handlers = {
        img: null,
        video: null
    }) {
        const tag = el.tagName;
        switch(tag){
            case "IMG":
                if (typeof media_handlers.img === "function") media_handlers.img.call((0, $b7a8c6d4d20803eb$export$2e2bcd8739ae039), el);
                break;
            case "VIDEO":
                if (typeof media_handlers.video === "function") media_handlers.video.call((0, $0cf9af5d9dc9aed9$export$2e2bcd8739ae039), el);
                break;
            default:
                break;
        }
    },
    init (card_wrapper_el, onLoaded) {
        const media_handlers = {
            img: (0, $b7a8c6d4d20803eb$export$2e2bcd8739ae039).addInteractionHandlers,
            video: (0, $0cf9af5d9dc9aed9$export$2e2bcd8739ae039).interactionHandler
        };
        const instance = new LazyLoad({
            container: card_wrapper_el,
            threshold: 300,
            callback_loaded: (el)=>{
                onLoaded(el);
                $68be57c3a737ff01$var$lazy_load._mediaFunctionCaller(el, media_handlers);
            },
            callback_finish: ()=>instance.destroy()
        });
    }
};
var $68be57c3a737ff01$export$2e2bcd8739ae039 = $68be57c3a737ff01$var$lazy_load;


// ScrollLock
// -------------------------------------------------------------------------------------------------------
const $c04221cd76aa24ac$var$scroll_lock = {
    disable: (scrollable_el)=>bodyScrollLock.disableBodyScroll(scrollable_el, {
            reserveScrollBarGap: true
        }),
    enable: (unscrollable_el)=>bodyScrollLock.enableBodyScroll(unscrollable_el)
};
var $c04221cd76aa24ac$export$2e2bcd8739ae039 = $c04221cd76aa24ac$var$scroll_lock;



//Movement
// -------------------------------------------------------------------------------------------------------
const $892a75d630045ffe$var$movement = {
    _easeInOutQuart (x) {
        if (x < 0.5) return 8 * x * x * x * x;
        else return 1 - Math.pow(-2 * x + 2, 4) / 2;
    },
    scrollToElementWithEasing (element, duration = 1200, callback) {
        const starting_y = window.scrollY;
        const element_y = window.scrollY + element.getBoundingClientRect().top;
        const target_y = document.body.scrollHeight - element_y < window.innerHeight ? document.body.scrollHeight - window.innerHeight : element_y;
        const diff = target_y - starting_y;
        let start;
        if (!diff) {
            if (typeof callback === "function") callback();
            return;
        }
        const frameStep = (timestamp)=>{
            if (!start) start = timestamp;
            const time = timestamp - start;
            let percent = Math.min(time / duration, 1);
            percent = this._easeInOutQuart(percent);
            window.scrollTo(0, starting_y + diff * percent);
            if (time < duration) window.requestAnimationFrame(frameStep);
            else if (typeof callback === "function") callback();
        };
        window.requestAnimationFrame(frameStep);
    }
};
var $892a75d630045ffe$export$2e2bcd8739ae039 = $892a75d630045ffe$var$movement;


//URL
// -------------------------------------------------------------------------------------------------------
const $4d1e4c99b6f3c63d$var$url = {
    _openProjectFromHash (hash) {
        const project_key = hash.substring(1);
        if ((0, $8e37dd3e331ed7f5$export$2e2bcd8739ae039).map.has(project_key)) {
            (0, $8e37dd3e331ed7f5$export$2e2bcd8739ae039).cards.closeAll();
            const el_pair = (0, $8e37dd3e331ed7f5$export$2e2bcd8739ae039).map.get(project_key);
            el_pair.card_el.open();
        }
    },
    getLocationHash () {
        return window.location.hash || false;
    },
    _addPopstateHandler () {
        window.addEventListener("popstate", ()=>{
            const hash = this.getLocationHash();
            if (hash) this._openProjectFromHash(hash);
            else {
                (0, $8e37dd3e331ed7f5$export$2e2bcd8739ae039).cards.closeAll();
                this.clearHash();
            }
        });
    },
    updateHash (hash) {
        hash = `#${hash}`;
        history.pushState(null, null, hash);
    },
    clearHash () {
        if (!window.location.hash) return;
        history.pushState(null, null, window.location.pathname);
    },
    init (thumbnails_section_el) {
        const hash = this.getLocationHash();
        if (hash) {
            if ("scrollRestoration" in history) history.scrollRestoration = "manual";
            (0, $892a75d630045ffe$export$2e2bcd8739ae039).scrollToElementWithEasing(thumbnails_section_el, undefined, ()=>{
                this._openProjectFromHash(hash);
            });
        }
        this._addPopstateHandler();
    }
};
var $4d1e4c99b6f3c63d$export$2e2bcd8739ae039 = $4d1e4c99b6f3c63d$var$url;


// Project Thumbnails / Cards
// -------------------------------------------------------------------------------------------------------
const $8e37dd3e331ed7f5$var$projects = {
    section_id: "projects",
    project_attr: "project",
    map: {},
    classes: {
        active: "active",
        card_wrapper: "project-card-wrapper",
        details: "project-description",
        button_close: "close-btn",
        button_details: "description-btn",
        media_container: "ratio-box",
        media_loading_text: "loading-text"
    },
    thumbnails: {
        _addProjectProperty (grid_items) {
            for (const item of grid_items){
                const item_el = item._element;
                const project_val = item_el.getAttribute($8e37dd3e331ed7f5$var$projects.project_attr);
                item.project = project_val;
            }
        },
        _createThumbnailMap (thumbnail_items) {
            const project_map = new Map();
            this._addProjectProperty(thumbnail_items);
            thumbnail_items.forEach((item)=>{
                const thumb_project_val = item.project;
                const matching_project_cards = $8e37dd3e331ed7f5$var$projects.card_wrapper_els.filter((el)=>{
                    const el_project_val = el.getAttribute($8e37dd3e331ed7f5$var$projects.project_attr);
                    return el_project_val === thumb_project_val;
                });
                if (matching_project_cards.length === 1) {
                    const el_pair = {
                        thumb_el: item._element,
                        card_el: matching_project_cards[0]
                    };
                    project_map.set(item.project, el_pair);
                }
            // else console.error(`projects: thumbnail match issue for ${item_project_val} -`, matching_thumb_el)
            });
            return project_map;
        },
        _addClickListeners (project_map) {
            const project_entries = project_map.entries();
            for (const [project, el_pair] of project_entries){
                const { thumb_el: thumb_el, card_el: card_el } = el_pair;
                thumb_el.addEventListener("click", ()=>{
                    $8e37dd3e331ed7f5$var$projects.cards.closeAll();
                    (0, $4d1e4c99b6f3c63d$export$2e2bcd8739ae039).updateHash(project);
                    card_el.open();
                });
            }
        },
        init (thumbnail_items) {
            $8e37dd3e331ed7f5$var$projects.map = this._createThumbnailMap(thumbnail_items);
            this._addClickListeners($8e37dd3e331ed7f5$var$projects.map);
        }
    },
    cards: {
        _initLazyLoad (card_wrapper_el) {
            card_wrapper_el.addEventListener("transitionend", ()=>{
                (0, $68be57c3a737ff01$export$2e2bcd8739ae039).init(card_wrapper_el, this._removeLoadingTextClass);
            }, {
                once: true
            });
        },
        _addOpenMethod (card_wrapper_el) {
            card_wrapper_el.has_been_opened = false;
            card_wrapper_el.open = ()=>{
                if (!card_wrapper_el.has_been_opened) {
                    card_wrapper_el.has_been_opened = true;
                    this._initLazyLoad(card_wrapper_el);
                }
                card_wrapper_el.classList.add($8e37dd3e331ed7f5$var$projects.classes.active);
                (0, $c04221cd76aa24ac$export$2e2bcd8739ae039).disable(card_wrapper_el);
            };
        },
        _addLoadingTextClasses (card_wrapper_el) {
            const media_containers = card_wrapper_el.querySelectorAll(`.${$8e37dd3e331ed7f5$var$projects.classes.media_container}`);
            const container_els = Array.from(media_containers);
            for (const container_el of container_els)container_el.classList.add($8e37dd3e331ed7f5$var$projects.classes.media_loading_text);
        },
        _removeLoadingTextClass (media_el) {
            const media_container = media_el.closest(`.${$8e37dd3e331ed7f5$var$projects.classes.media_container}`);
            media_container.classList.remove($8e37dd3e331ed7f5$var$projects.classes.media_loading_text);
        },
        _addCloseButtonListener (card_wrapper_el) {
            const close_el = card_wrapper_el.querySelector(`.${$8e37dd3e331ed7f5$var$projects.classes.button_close}`);
            close_el.addEventListener("click", ()=>{
                (0, $4d1e4c99b6f3c63d$export$2e2bcd8739ae039).clearHash();
                card_wrapper_el.classList.remove($8e37dd3e331ed7f5$var$projects.classes.active);
                (0, $c04221cd76aa24ac$export$2e2bcd8739ae039).enable(card_wrapper_el);
            });
        },
        _addDetailsButtonListener (card_wrapper_el) {
            const button_el = card_wrapper_el.querySelector(`.${$8e37dd3e331ed7f5$var$projects.classes.button_details}`);
            const details_el = card_wrapper_el.querySelector(`.${$8e37dd3e331ed7f5$var$projects.classes.details}`);
            function updateMaxHeight() {
                const scroll_height = details_el.scrollHeight;
                const max_height_val = `${scroll_height}px`;
                if (details_el.style.maxHeight !== max_height_val) details_el.style.maxHeight = max_height_val;
            }
            button_el.addEventListener("click", ()=>{
                if (details_el.classList.contains($8e37dd3e331ed7f5$var$projects.classes.active)) {
                    window.removeEventListener("resize", updateMaxHeight);
                    details_el.style.maxHeight = "";
                } else {
                    updateMaxHeight();
                    window.addEventListener("resize", updateMaxHeight);
                }
                button_el.classList.toggle($8e37dd3e331ed7f5$var$projects.classes.active);
                details_el.classList.toggle($8e37dd3e331ed7f5$var$projects.classes.active);
            });
        },
        closeAll () {
            for (const card_wrapper_el of $8e37dd3e331ed7f5$var$projects.card_wrapper_els)if (card_wrapper_el.classList.contains($8e37dd3e331ed7f5$var$projects.classes.active)) {
                (0, $4d1e4c99b6f3c63d$export$2e2bcd8739ae039).clearHash();
                card_wrapper_el.classList.remove($8e37dd3e331ed7f5$var$projects.classes.active);
                (0, $c04221cd76aa24ac$export$2e2bcd8739ae039).enable(card_wrapper_el);
                return;
            }
        },
        init (card_wrapper_els) {
            for (const card_wrapper_el of card_wrapper_els){
                this._addOpenMethod(card_wrapper_el);
                this._addLoadingTextClasses(card_wrapper_el);
                this._addCloseButtonListener(card_wrapper_el);
                this._addDetailsButtonListener(card_wrapper_el);
            }
        }
    },
    init (thumbnail_items) {
        const section_el = document.getElementById(this.section_id);
        this.card_wrapper_els = Array.from(section_el.querySelectorAll(`.${this.classes.card_wrapper}`));
        this.thumbnails.init(thumbnail_items);
        this.cards.init(this.card_wrapper_els);
    }
};
var $8e37dd3e331ed7f5$export$2e2bcd8739ae039 = $8e37dd3e331ed7f5$var$projects;




//Nav Bar
// -------------------------------------------------------------------------------------------------------
const $1662bc76e0a93855$var$nav_bar = {
    breakpoint: 400,
    ids: {
        title: "nav-title",
        links: "nav-links",
        burger_menu: "nav-burger"
    },
    _getEls () {
        this.title_el = document.getElementById(this.ids.title);
        this.links_el = document.getElementById(this.ids.links);
        this.burger_el = document.getElementById(this.ids.burger_menu);
    },
    createNewLink (text, attrs = {
        id: null,
        href: null
    }) {
        const { id: id, href: href } = attrs;
        const anchor_el = document.createElement("a");
        anchor_el.innerText = text;
        if (id) anchor_el.id = id;
        if (href) anchor_el.href = href;
        const item_el = document.createElement("li");
        item_el.appendChild(anchor_el);
        this.links_el.appendChild(item_el);
        return anchor_el;
    },
    addClickListener (anchor_el, fn) {
        anchor_el.addEventListener("click", ()=>{
            (0, $8e37dd3e331ed7f5$export$2e2bcd8739ae039).cards.closeAll();
            fn();
        });
    },
    _toggleDisplay (el) {
        const computed = window.getComputedStyle(el);
        const computed_value = computed.getPropertyValue("display");
        const toggle_value = computed_value === "block" ? "none" : "block";
        el.style.display = toggle_value;
    },
    _initBurgerMenu () {
        const burger_el = this.burger_el;
        const toggle_els = [
            this.links_el,
            this.title_el
        ];
        burger_el.addEventListener("click", ()=>{
            toggle_els.forEach((el)=>this._toggleDisplay(el));
        });
        let is_above_breakpoint = window.innerWidth > this.breakpoint;
        window.addEventListener("resize", ()=>{
            const currently_above_breakpoint = window.innerWidth > this.breakpoint;
            if (currently_above_breakpoint !== is_above_breakpoint) {
                is_above_breakpoint = currently_above_breakpoint;
                if (currently_above_breakpoint) toggle_els.forEach((el)=>el.style.display = "");
            }
        });
    },
    init (thumbnails_section_el) {
        this._getEls();
        this._initBurgerMenu();
        const work_link_el = this.createNewLink("Work", {
            id: "work",
            href: null
        });
        this.addClickListener(work_link_el, (0, $892a75d630045ffe$export$2e2bcd8739ae039).scrollToElementWithEasing.bind((0, $892a75d630045ffe$export$2e2bcd8739ae039), thumbnails_section_el));
    }
};
var $1662bc76e0a93855$export$2e2bcd8739ae039 = $1662bc76e0a93855$var$nav_bar;



//Three JS
// -------------------------------------------------------------------------------------------------------
const $9c7660da6e297490$var$three = {
    parent_ids: {
        hand: "hand-scene",
        bust: "bust-scene"
    },
    classes: {
        canvas: "three-canvas",
        slide: "slide"
    },
    files: {
        hand_gltf: "./three/scenes/Hand_2024_ForWeb-v3(compressed).glb",
        bust_gltf: "./three/scenes/Bust_2024_ForWeb(compressed).glb",
        hrd: "./three/hdr/hdri_studio_softbox_varA_v001.webp"
    },
    configs: {
        hand: {
            y_pos: 0.2,
            aspect_w: 1,
            camera_fov: 30,
            camera_dist: 20,
            start_animated: true
        },
        bust: {
            y_pos: 0,
            aspect_w: 1.3,
            camera_fov: 15,
            camera_dist: 45,
            start_animated: false
        }
    },
    loaders: {
        gltf: null,
        texture: null
    },
    scenes: new Map(),
    utilities: {
        degToRad (degrees) {
            return degrees * (Math.PI / 180);
        },
        mapValue (value, from_range, to_range) {
            const [from_low, from_high] = from_range;
            const [to_low, to_high] = to_range;
            return to_low + (value - from_low) / (from_high - from_low) * (to_high - to_low);
        }
    },
    initLoaders () {
        const gltf_loader = new window.GLTFLoader();
        const draco_loader = new window.DRACOLoader();
        const texture_loader = new window.THREE.TextureLoader();
        //Draco neccessary if using Draco compression (done via Khronos'site)
        draco_loader.setDecoderPath("./script/draco/");
        gltf_loader.setDRACOLoader(draco_loader);
        this.loaders = {
            texture: texture_loader,
            gltf: gltf_loader
        };
    },
    initClasses () {
        class SceneBase {
            constructor(parent_el, config = {
                y_pos: 0,
                aspect_w: 1.1,
                camera_fov: 30,
                camera_dist: 20,
                scene_rotate: 0
            }){
                this.parent_el = parent_el;
                this.config = config;
                parent_el.style["aspect-ratio"] = `${config.aspect_w} / 1`;
                const { width: parent_width, height: parent_height } = this._getParentSize();
                this.is_in_debug = false;
                this.scene = new THREE.Scene();
                this.camera = new THREE.PerspectiveCamera(this.config.camera_fov, parent_width / parent_height, 0.1, 1000);
                this.renderer = new THREE.WebGLRenderer({
                    antialias: true,
                    alpha: true
                });
                this._setupCamera();
                this._setupRenderer();
                this._setupHDR();
                this._rotateSceneAndCamera(80);
                this._addLights();
                this._setupResizeHandler();
                this.renderer.setSize(parent_width, parent_height);
                this.parent_el.appendChild(this.renderer.domElement);
                this.renderer.domElement.classList.add($9c7660da6e297490$var$three.classes.canvas);
                if (this.is_in_debug) {
                    this.orbit_controls = new window.OrbitControls(this.camera, this.renderer.domElement);
                    this.parent_el.style.backgroundColor = "#000000";
                }
            }
            _setupCamera() {
                this.camera.position.set(0, 0, this.config.camera_dist);
            }
            _setupRenderer() {
                this.renderer.setSize(window.innerWidth, window.innerHeight);
                this.renderer.setClearColor("#FFFFFF", 0); //Background color
                this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
                this.renderer.toneMappingExposure = 1.3; // Hdri brightness
            }
            _setupHDR() {
                $9c7660da6e297490$var$three.loaders.texture //Change Loader for HDR
                // .setDataType(THREE.HalfFloatType) // For HDR
                .load($9c7660da6e297490$var$three.files.hrd, (texture)=>{
                    texture.mapping = THREE.EquirectangularReflectionMapping;
                    this.scene.environment = texture;
                    if (this.is_in_debug) {
                        // Create environment helper
                        const sphere_geometry = new THREE.SphereGeometry(10, 10, 10);
                        // THREE.BackSide renders inside
                        const sphere_material = new THREE.MeshBasicMaterial({
                            map: texture,
                            side: THREE.BackSide
                        });
                        const sphere_mesh = new THREE.Mesh(sphere_geometry, sphere_material);
                        // sphere_mesh.rotation.y = three.utilities.degToRad(0);
                        this.scene.add(sphere_mesh);
                    }
                });
            }
            _rotateSceneAndCamera(deg) {
                const angle = $9c7660da6e297490$var$three.utilities.degToRad(deg);
                // Rotate Camera
                this.camera.position.applyAxisAngle(new THREE.Vector3(0, 1, 0), angle);
                this.camera.lookAt(this.scene.position);
                // Rotate all objects and lights in the scene in the opposite direction
                this.scene.traverse((object)=>{
                    if (object.isMesh) object.rotation.y -= angle;
                });
            }
            _addLights() {
                const directional_light = new THREE.DirectionalLight("#FFFFFF", 1);
                directional_light.position.set(10, 5.5, 2);
                directional_light.castShadow = true; // Doesn't seem to do anything
                directional_light.intensity = 2;
                this.scene.add(directional_light);
                if (this.is_in_debug) {
                    // Create directional light helper
                    const lightHelper = new THREE.DirectionalLightHelper(directional_light, 5); // The second parameter = size
                    this.scene.add(lightHelper);
                }
            }
            _getParentSize() {
                const rect_size = this.parent_el.getBoundingClientRect();
                const { width: width, height: height } = rect_size;
                return {
                    width: width,
                    height: height
                };
            }
            _setupResizeHandler() {
                window.addEventListener("resize", ()=>{
                    const { width: parent_width, height: parent_height } = this._getParentSize();
                    this.renderer.setSize(parent_width, parent_height);
                    this.camera.aspect = parent_width / parent_height;
                    this.camera.updateProjectionMatrix();
                });
            }
        }
        class Scene extends SceneBase {
            constructor(source_file, parent_el, config){
                super(parent_el, config);
                this.source_file = source_file;
                this.mesh = null;
                this.is_animating = config.start_animated;
                this.rotation = {
                    limits: {
                        min: -0.03,
                        max: 0.03
                    },
                    default_val: -0.01,
                    user_val: null,
                    is_default_rotating: true
                };
                this.zoom = {
                    limits: {
                        min: 0.3,
                        max: 2
                    }
                };
            }
            isWithinViewport() {
                const parentRect = this.parent_el.getBoundingClientRect();
                const withinHorizontalBounds = parentRect.right > 0 && parentRect.left < window.innerWidth;
                const withinVerticalBounds = parentRect.bottom > 0 && parentRect.top < window.innerHeight;
                return withinHorizontalBounds && withinVerticalBounds;
            }
            startAnimation() {
                if (!this.is_animating) {
                    this.is_animating = true;
                    this._animate();
                }
            }
            stopAnimation() {
                if (this.is_animating) this.is_animating = false;
            }
            async init() {
                const slide_el = this.parent_el.closest(`.${$9c7660da6e297490$var$three.classes.slide}`);
                await this._loadModel();
                this._setupMousePassiveHandler(slide_el);
                this._setupMouseControlHandler(slide_el);
                this._animate();
            }
            _animate() {
                if (!this.is_animating) return;
                this.renderer.render(this.scene, this.camera);
                this._defaultMeshRotation();
                if (this.is_in_debug) this.orbit_controls.update();
                requestAnimationFrame(()=>this._animate());
            }
            _loadModel() {
                return new Promise((resolve, reject)=>{
                    $9c7660da6e297490$var$three.loaders.gltf.load(this.source_file, (gltf)=>{
                        this.mesh = gltf.scene;
                        this.mesh.position.set(0, this.config.y_pos, 0);
                        this.mesh.scale.set(1, 1, 1);
                        this.scene.add(this.mesh);
                        if (this.is_in_debug) {
                            const axis = new THREE.AxesHelper(4);
                            this.mesh.add(axis);
                        }
                        resolve();
                    }, undefined, (error)=>{
                        console.error("An error occurred loading the GLTF model:", error);
                        reject(error);
                    });
                });
            }
            _defaultMeshRotation() {
                if (!this.rotation.is_default_rotating) return;
                this.mesh.rotation.y += this.rotation.user_val ?? this.rotation.default_val;
            }
            _setupMousePassiveHandler(element) {
                element.addEventListener("mousemove", (e)=>{
                    const width = element.offsetWidth;
                    const center_x = width / 2;
                    let elementRect = element.getBoundingClientRect();
                    const mouse_x = e.clientX - elementRect.left;
                    const relative_x = mouse_x - center_x;
                    const mapped = $9c7660da6e297490$var$three.utilities.mapValue(relative_x, [
                        -center_x,
                        center_x
                    ], [
                        this.rotation.limits.min,
                        this.rotation.limits.max
                    ]);
                    this.rotation.user_val = mapped;
                });
                element.addEventListener("mouseleave", ()=>{
                    if (this.rotation.user_val) this.rotation.user_val = null;
                });
            }
            _setupMouseControlHandler(element) {
                let is_dragging = false;
                let prev_touch_pos = {
                    x: 0,
                    y: 0
                };
                element.style.cursor = "url('../images/icon-3d_rotate.svg'), all-scroll";
                const getMidpoint = (touch1, touch2)=>({
                        x: (touch1.clientX + touch2.clientX) / 2,
                        y: (touch1.clientY + touch2.clientY) / 2
                    });
                const onStart = (clientX, clientY)=>{
                    is_dragging = true;
                    this.rotation.is_default_rotating = false;
                    prev_touch_pos.x = clientX;
                    prev_touch_pos.y = clientY;
                };
                const onMove = (clientX, clientY)=>{
                    if (is_dragging) {
                        const delta_x = clientX - prev_touch_pos.x;
                        const delta_y = clientY - prev_touch_pos.y;
                        // Rotation
                        const rotation_speed = 0.005; // Adjust sensitivity
                        this.mesh.rotation.y += delta_x * rotation_speed;
                        this.mesh.rotation.z -= delta_y * rotation_speed;
                        // Clamp X-axis rotation to prevent flipping
                        this.mesh.rotation.z = Math.max(-Math.PI / 2, Math.min(Math.PI / 2, this.mesh.rotation.z));
                        prev_touch_pos.x = clientX;
                        prev_touch_pos.y = clientY;
                    }
                };
                const onEnd = ()=>{
                    is_dragging = false;
                    this.rotation.is_default_rotating = true;
                };
                // Mouse events
                element.addEventListener("mousedown", (e)=>onStart(e.clientX, e.clientY));
                document.addEventListener("mousemove", (e)=>onMove(e.clientX, e.clientY));
                document.addEventListener("mouseup", onEnd);
                element.addEventListener("mouseleave", onEnd);
                // Touch events
                element.addEventListener("touchstart", (e)=>{
                    if (e.touches.length === 2) {
                        e.preventDefault();
                        const midpoint = getMidpoint(e.touches[0], e.touches[1]);
                        onStart(midpoint.x, midpoint.y);
                    }
                }, {
                    passive: false
                });
                element.addEventListener("touchmove", (e)=>{
                    if (e.touches.length === 2) {
                        e.preventDefault();
                        const midpoint = getMidpoint(e.touches[0], e.touches[1]);
                        onMove(midpoint.x, midpoint.y);
                    }
                }, {
                    passive: false
                });
                element.addEventListener("touchend", onEnd);
                element.addEventListener("touchcancel", onEnd);
            }
        }
        return {
            SceneBase: SceneBase,
            Scene: Scene
        };
    },
    startAllSceneAnimation () {
        this.scenes.forEach((scene)=>scene.startAnimation());
    },
    toggleViewportSceneAnimation () {
        this.scenes.forEach((scene)=>{
            const is_within_viewport = scene.isWithinViewport();
            is_within_viewport ? scene.startAnimation() : scene.stopAnimation();
        });
    },
    setupWindowVisibilityHandler () {
        window.addEventListener("scroll", ()=>this.toggleViewportSceneAnimation());
    },
    async init () {
        this.initLoaders();
        const { Scene: Scene } = this.initClasses();
        this.Scene = Scene;
        const hand_parent_el = document.getElementById(this.parent_ids.hand);
        const hand_scene = new this.Scene(this.files.hand_gltf, hand_parent_el, this.configs.hand);
        this.scenes.set("hand", hand_scene);
        const bust_parent_el = document.getElementById(this.parent_ids.bust);
        const bust_scene = new this.Scene(this.files.bust_gltf, bust_parent_el, this.configs.bust);
        this.scenes.set("bust", bust_scene);
        this.setupWindowVisibilityHandler();
        await hand_scene.init();
        await bust_scene.init();
    }
};
var $9c7660da6e297490$export$2e2bcd8739ae039 = $9c7660da6e297490$var$three;


//Intro Slider
// -------------------------------------------------------------------------------------------------------
const $6da2f0ce7e4f851a$var$intro_slider = {
    id: "intro-slider",
    title_id: "nav-title",
    map: new Map([
        [
            "intro",
            {
                id: "greeting",
                anchor_text: null
            }
        ],
        [
            "about",
            {
                id: "profile",
                anchor_text: "Profile"
            }
        ]
    ]),
    _addClickToSlide (anchor_el, slide) {
        anchor_el.addEventListener("click", ()=>{
            (0, $8e37dd3e331ed7f5$export$2e2bcd8739ae039).cards.closeAll();
            this.moveToSlide(slide);
        });
    },
    _createAnchor (slide, slide_on_click = true) {
        const text = slide.anchor_text;
        const id = slide.id;
        const attrs = {
            id: id
        };
        const anchor_el = (0, $1662bc76e0a93855$export$2e2bcd8739ae039).createNewLink(text, attrs);
        if (slide_on_click) this._addClickToSlide(anchor_el, slide);
        return anchor_el;
    },
    _initSlides () {
        const map = this.map;
        const slide_keys = map.keys();
        for (const slide_key of slide_keys){
            const slide = map.get(slide_key);
            slide.el = this.el.querySelector(`#${slide.id}`);
            slide.index = this.slide_els.indexOf(slide.el);
        }
        const title_el = document.getElementById(this.title_id);
        const intro_slide = map.get("intro");
        this._addClickToSlide(title_el, intro_slide);
        const about_slide = map.get("about");
        about_slide.anchor_el = this._createAnchor(about_slide);
    },
    _addTransitionEndHandler () {
        this.el.addEventListener("transitionend", ()=>{
            (0, $9c7660da6e297490$export$2e2bcd8739ae039).toggleViewportSceneAnimation();
        });
    },
    moveToSlide (slide) {
        const slider = this.el;
        const base_offset = slider.offsetLeft;
        const top_offset = slider.getBoundingClientRect().top;
        const slide_offset = slide.el.getBoundingClientRect().left - base_offset;
        if (top_offset) (0, $892a75d630045ffe$export$2e2bcd8739ae039).scrollToElementWithEasing(slider);
        if (slide_offset) {
            (0, $9c7660da6e297490$export$2e2bcd8739ae039).startAllSceneAnimation();
            const fraction = -slide.index / (this.length - 1);
            const percent = 100 * fraction;
            this.el.style.transform = `translateX(${percent}%)`;
        }
    },
    init () {
        this.el = document.getElementById(this.id);
        this.slide_els = Array.from(this.el.children);
        this.length = this.slide_els.length;
        this._initSlides();
        this._addTransitionEndHandler();
    }
};
var $6da2f0ce7e4f851a$export$2e2bcd8739ae039 = $6da2f0ce7e4f851a$var$intro_slider;



// Thumbnail filter
// -------------------------------------------------------------------------------------------------------
const $2ae3b99ff4a14da4$var$filter = {
    select: {
        id: "thumbnails-filter",
        attribute_name: "categories",
        _filterHandler (muuri_grid, filter_category) {
            const attribute_name = this.attribute_name;
            if (filter_category) muuri_grid.filter((item)=>{
                const category_attribute_str = item.getElement().getAttribute(attribute_name);
                const categories_arr = category_attribute_str.split(" ");
                return categories_arr.includes(filter_category);
            });
            else muuri_grid.show(muuri_grid.items);
        },
        _addChangeListener (muuri_grid) {
            const filter_field_el = document.getElementById(this.id);
            filter_field_el.addEventListener("change", (e)=>{
                const category = e.target.value.toLowerCase();
                this._filterHandler(muuri_grid, category);
            });
        },
        init (muuri_grid) {
            this._addChangeListener(muuri_grid);
        }
    },
    random: {
        id: "filter-randomize",
        shuffleItems (items_arr) {
            const length = items_arr.length;
            for(let i = length - 1; i > 0; i--){
                const random_index = Math.floor(Math.random() * (i + 1));
                const temp_element = items_arr[i];
                items_arr[i] = items_arr[random_index];
                items_arr[random_index] = temp_element;
            }
            return items_arr;
        },
        randomizeHandler (muuri_grid) {
            const items_arr = muuri_grid.items;
            const shuffled_items_arr = this.shuffleItems(items_arr);
            muuri_grid.refreshSortData(shuffled_items_arr);
            muuri_grid.sort(items_arr);
        },
        _addClickListener (muuri_grid) {
            const randomize_button_el = document.getElementById(this.id);
            randomize_button_el.addEventListener("click", ()=>this.randomizeHandler(muuri_grid));
        },
        init (muuri_grid) {
            this._addClickListener(muuri_grid);
        }
    },
    init (muuri_grid) {
        this.select.init(muuri_grid);
        this.random.init(muuri_grid);
    }
};
var $2ae3b99ff4a14da4$export$2e2bcd8739ae039 = $2ae3b99ff4a14da4$var$filter;


// Muuri
// -------------------------------------------------------------------------------------------------------
const $e7a455e4c2d34fd3$var$murri = {
    options: {
        layoutOnInit: true,
        dragEnabled: false,
        containerClass: "grid",
        itemClass: "item",
        itemVisibleClass: "shown",
        itemHiddenClass: "hidden"
    },
    _randomizedBoolean () {
        return Math.random() >= 0.5 ? true : false;
    },
    _addConstructorOptions (options) {
        options.alignRight = this._randomizedBoolean();
    },
    _preShuffleItems (grid_el, shuffleFn) {
        const item_nodes = grid_el.querySelectorAll(`.${this.options.itemClass}`);
        const items_arr = Array.from(item_nodes);
        const shuffled_arr = shuffleFn(items_arr);
        shuffled_arr.forEach((item)=>grid_el.appendChild(item));
    },
    init () {
        this._addConstructorOptions(this.options);
        const grid_el = document.querySelector(`.${this.options.containerClass}`);
        const shuffleFn = (0, $2ae3b99ff4a14da4$export$2e2bcd8739ae039).random.shuffleItems;
        this._preShuffleItems(grid_el, shuffleFn);
        const grid = new Muuri(grid_el, this.options);
        const items = grid.getItems();
        this.grid = grid;
        this.grid.items = items;
        (0, $2ae3b99ff4a14da4$export$2e2bcd8739ae039).init(grid);
    }
};
var $e7a455e4c2d34fd3$export$2e2bcd8739ae039 = $e7a455e4c2d34fd3$var$murri;






(async function run() {
    const thumbnails_section_el = document.getElementById("projects-thumbnails");
    (0, $9ddde22dc8a5d9b0$export$2e2bcd8739ae039).init();
    (0, $1662bc76e0a93855$export$2e2bcd8739ae039).init(thumbnails_section_el);
    await (0, $9c7660da6e297490$export$2e2bcd8739ae039).init();
    (0, $6da2f0ce7e4f851a$export$2e2bcd8739ae039).init();
    (0, $b7e814115a0b0754$export$2e2bcd8739ae039).init();
    (0, $4d1e4c99b6f3c63d$export$2e2bcd8739ae039).init(thumbnails_section_el);
    (0, $e7a455e4c2d34fd3$export$2e2bcd8739ae039).init();
    (0, $8e37dd3e331ed7f5$export$2e2bcd8739ae039).init((0, $e7a455e4c2d34fd3$export$2e2bcd8739ae039).grid.items);
    preload.remove();
})();

})();
//# sourceMappingURL=portfolio.js.map
